import { PageLink } from "../../../../../_metronic/layout/core"
import { EMatchingPaymentTicketStatus } from "../../../../../types/enums"
import { getDefaultDateRange } from "../../../../../utils/getDefaultDateRange"
import { matchingCapabilities, MatchingPaymentFinishedTicketsFilters, MatchingPaymentTicketListObject } from "../../core/_models"


const defaultList: MatchingPaymentTicketListObject = {}
const perPage = 20

export const breadcrumbs: Array<PageLink> = [
  {
    title: 'Активные пополнения',
    path: '/matching/payment/active',
    isSeparator: false,
    isActive: false,
    roles: matchingCapabilities.canViewFinishedPayments,
  },
  {
    title: 'Завершённые пополнения',
    path: '/matching/payment/finished',
    isSeparator: false,
    isActive: true,
    roles: matchingCapabilities.canViewFinishedPayments,
  },
]

const relevantStatusList: Array<EMatchingPaymentTicketStatus> = [
  EMatchingPaymentTicketStatus.DECLINED,
  EMatchingPaymentTicketStatus.COMPLETED,
  EMatchingPaymentTicketStatus.EXPIRED,
]

const defaultDateRange = getDefaultDateRange()

const defaultFilters: MatchingPaymentFinishedTicketsFilters = {
  byCompletionDate: false,
  dateEnd:
    defaultDateRange.endDate instanceof Date
      ? defaultDateRange.endDate
      : new Date(defaultDateRange.endDate),
  dateStart:
    defaultDateRange.startDate instanceof Date
      ? defaultDateRange.startDate
      : new Date(defaultDateRange.startDate),
  statusList: relevantStatusList,
  search: undefined,
  merchantTokenList: [],
}

export const matchingFinishedPaymentsConfig = {
  breadcrumbs,
  defaultList,
  defaultDateRange,
  perPage,
  relevantStatusList,
  defaultFilters,
}